define([
    "./nlgTemplateModule",
    "./nlgTemplateDirective"
], function(){});